var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRight = function SvgRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M61 40a1 1 0 0 0-.305-.719l-30-29a1 1 0 1 0-1.39 1.438L58.561 40 29.305 68.281a1 1 0 0 0 1.39 1.438l30-29A1 1 0 0 0 61 40",
    clipRule: "evenodd"
  })));
};
export default SvgRight;